import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { LessonsWrapper } from '../../components/Styled/StyledWrappers';

export const Lessons: React.FC<RouteComponentProps> = (props): JSX.Element => {
  return <LessonsWrapper data-testid="lessons-wrapper">{props.children}</LessonsWrapper>;
};
